<section role="region" class="wrapper--blue banner">
  <div class="banner__container">
    <h2>
      <span class="line-break">{{ bannerConfig?.mainTitle }}</span>
      <span class="highlight--white">{{ bannerConfig?.emphasis }} </span>
    </h2>
    <p>
      {{ bannerConfig?.text }}
    </p>
  </div>

  <div class="banner__content">
    <ng-content></ng-content>
  </div>
</section>
